import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Order } from '../../shared/entities/order';
import { CoilSheet } from '../../shared/entities/coilSheet';
import { ExportDialogComponent } from '../export-dialog/export-dialog.component';
import { CommonModule, DatePipe } from '@angular/common';
import { ExportData } from '../../shared/entities/export';
import { EventEmitterService } from '../../shared/services/event-emitter.service';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { CoilDetailDialogComponent } from '../coil-detail-dialog/coil-detail-dialog.component';
import { ButtonModule } from 'primeng/button';
import { MatIconModule } from '@angular/material/icon';
import { MeasurementsDataService } from '../../shared/services/measurements-data.service';

@Component({
  selector: 'app-order-detail',
  standalone: true,
  imports: [
    ExportDialogComponent,
    CommonModule,
    ButtonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatDialogTitle, 
    MatDialogContent,
    CoilDetailDialogComponent
  ],
  providers: [DatePipe],
  templateUrl: './order-detail.component.html',
  styleUrl: './order-detail.component.scss'
})
export class OrderDetailComponent {
  regionMeasurementUnits: any = {};
  displayedColumns: string[] = ['coilSheetId', 'width', 'thickness', 'gradeType', 'coilDetails'];
  orderCoilsExists: boolean = false;
  showExportDialog: boolean = false;
  exportedCoils: CoilSheet[] = [];

  @Input() selectedCoil: CoilSheet = {};

  @Input()
  coil: CoilSheet = {};

  @Input()
  get order() {
    return this._order;
  }
  set order(value: Order) {
    this._order = value;
  }
  private _order: Order = {};

  @Input()
  get rowDataCoil() {
    return this._rowDataCoil;
  }
  set rowDataCoil(value: any) {
    this._rowDataCoil = value;
    if (this.rowDataCoil && this.rowDataCoil.length > 0) {
      this.rowDataCoil.forEach((item: any) => {
        if(this.selectedCoil._id === item._id){
          item.selected = true;
        }else {
          item.selected = false;
        }
      });
      this.orderCoilsExists = true;
    } else {
      this.orderCoilsExists = false;
    }
  }
  private _rowDataCoil: any = [];

  @Input()
  hideTitle: boolean = false;

  @Output()
  exportAllData: EventEmitter<any> = new EventEmitter();

  @Output()
  coilNrClicked: EventEmitter<any> = new EventEmitter();

  @Output()
  coilSelectionChanged: EventEmitter<any> = new EventEmitter();

  constructor( 
    private eventEmitterService: EventEmitterService,
    public dialog: MatDialog,
    private measurementsDataService: MeasurementsDataService) {
      this.regionMeasurementUnits = this.measurementsDataService.regionMeasurementUnits();
    }


  emitExportData() {
    const exampleExportData: ExportData = {
      exportFrom: 'Order',
      exportId: this._order.salesOrderNumber,
      selectedGraph: {key:'',label:''},
      coilSheetsToExport: this.rowDataCoil
    };
    this.eventEmitterService.get<ExportData>('exportData').emit(exampleExportData);
  }

  showDialog() {
    if(this.rowDataCoil && this.rowDataCoil.length > 0){
      this.exportedCoils = this.rowDataCoil;
    }
    this.emitExportData();
    this.showExportDialog = true;
  }

  onDialogClose(event: boolean) {
    this.showExportDialog = event;
  }

  onRowClicked(row: any) {
    this.rowDataCoil.forEach((item: any) => {
      if(row._id === item._id && !item.selected) {
        item.selected = true;
      }else {
        item.selected = false;
      }
    });
    const selectedRows = this.rowDataCoil;
    if (selectedRows && selectedRows.length > 0) {
     this.coilNrClicked.emit(row);
    }
  }

  openCoilDetailDialog(row: any) {
    const dialogRef = this.dialog.open(CoilDetailDialogComponent, {
      disableClose: true,
      data: row
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}